import axios from "axios";
import { toast } from 'react-toastify';

const axiosInstance = axios.create({
  headers: {
    "Content-Type": "application/json",
    Accept: "application/json",
  },
}); 

export const handleFileValidation = (e, setFile,  setError = () => {}) => {
  const file = e.target.files[0];
  const maxSize = 4 * 1024 * 1024; 

  if (file) {
    if (file.type.startsWith("image/") && !file.type.endsWith("gif")&& !file.type.endsWith("avif")) {
      if (file.size <= maxSize) {
        setFile(file);
        setError(false);
      } else {
        toast.error("File size must be less than 4MB.");
        setFile(null);
        e.target.value = null; 
      }
    } else {
      toast.error("Only PNG, JPG, and JPEG files are allowed.");
      setFile(null);
      e.target.value = null; 
    }
  }
};
export const urlPath = window.location.host;  
export const getEnvUrl = () => {
  return process.env.REACT_APP_API_URL+"api";
};

export const getGamePlayUrl = () => {
  return process.env.REACT_APP_API_URL;
};

export const getMediaUrl = () => { 
  return process.env.REACT_APP_MEDIA_URL;
}; 
export const getToken = () => {
    return localStorage.getItem("token");
  };
  axiosInstance.defaults.baseURL = getEnvUrl();
  export {axiosInstance};